import RecoverStep from "../recover_step";
import {isExportToDisk} from "../../utils/recover_utils";
import {AJAX_DATA_TYPE_JSON} from "../../utils/recover_consts";

const TEMPLATE = 'offsite-recovery-point';

export default class SetRecoveryPoint extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        if (data.jobs[data.recovery.job_id].type === 'FILE' ) {
            delete data.recovery.drive;
        }
        const firstJob = Object.keys(data.jobs)[0];

        if (firstJob && data.jobs[firstJob].type === "SERVER_ALIVE_BMR" && data.jobs[firstJob].drives.length > 1) {
            if (data.recovery.virtualization && data.recovery.virtualization.location && data.recovery.virtualization.location === "vm-export") {
                data.tmp.previousStep = "setDevice";
            } else if (data.recovery.drive){
                data.tmp.previousStep = "setDrive";
            } else {
                data.tmp.previousStep = "setJob";
            }
        } else if (firstJob && Object.keys(data.jobs).length > 1) {
            data.tmp.previousStep = "setJob";
        } else if (data.deviceId) {
            data.tmp.previousStep = "restoreType";
        } else {
            data.tmp.previousStep = "setDevice";
        }
        data.render = { searchComplete : false };
        data.timeline = { selected: null, dpoint: null };
        fr.callMethod("loadRP");
    }

    postRender(data, el, fr) {
        if (data.render.searchComplete) {
            $('#recovery-point-date-picker').datepicker({
                onSelect: function(date) {
                    data.timeline = { selected: date, dpoint: new Date(date).getDatePoint() };
                    fr.callMethod('loadRP');
                }
            }).keyup(function(event) {
                if (event.which === $.ui.keyCode.ENTER) {
                    $('.ui-datepicker-current-day').click();
                    event.preventDefault();
                }
            });

					$('.calendar-picker .input-group-append').click(function() {
						$(this).parents('.input-group').find('.form-control').focus();
					});
        }
    }

    loadRP(data, el, fr) {
        const renderRecoveryPoints = function () {
            data.render.searchComplete = true;
            fr.render('setRecoveryPoint');
            fr.callMethod("timeline");
        };

        const day_point = (data.timeline.dpoint) ? '/' + data.timeline.dpoint : '';
        const baseUrl = ((data.restore && data.restore.type && (data.restore.type === "cloud")) ? "/api/filebrowsing/recovery_points/" : "/api/localbrowsing/recovery_points/");

        $.ajax({
            type : "GET",
            url : baseUrl + '/' + data.clientId + '/' + data.recovery.appliance_id + '/'
                + data.recovery.device_asid + '/' + data.recovery.job_id + '/' + data.recovery.drive + day_point,
            success: function (response) {
                if (!response.data){
                    data.tmp.applianceOffline = {back : data.tmp.previousStep, tryAgain : "setRecoveryPoint"};
                    fr.goTo("applianceOffline");
                } else {
                    data.recovery_dates = response.data.dates;
                    data.timeline.min = response.data.min;
                    data.timeline.max = response.data.max;
                    data.timeline.prev = response.data.prev;
                    data.timeline.next = response.data.next;
                    renderRecoveryPoints();
                }
            },
            dataType: AJAX_DATA_TYPE_JSON,
            contentType: "application/json"
        }).fail(fr.defaultAJAXErrorHandler);
    }

    timeline(data, el, fr) {
        const dates = data.recovery_dates;
        const template = $('.recovery-point-date');

        $('.recovery-day-picker .picker-area').empty();

        for (let i = 0; i < 7; i++) {
            const j = template.clone();
            const item = dates[i];

            if (item.date) {
                $(j).data('dpoint', item.date.dpoint);
                $(j).data('date', item.date.full);
                $(j).find('h5').text(item.date.month);
                $(j).find('.day').text(item.date.day);
                $(j).find('.year').text(item.date.year);
                $(j).find('.points .val').text(item.count);
                $(j).find('.points').addClass((item.count > 1)? '' : 'one');

                // See if we can find at least on rp that is enabled; in that case we enable the date.
                let disableDate = true;
                let points = item.points;
                for (let k = 0; k < points.length; k++) {
                    if (points[k].enabled) {
                        disableDate = false;
                        break;
                    }
                }
                if (disableDate) {
                    $(j).addClass('disabled');
                }
            } else {
                $(j).addClass('no-rpts');
            }

            $('.recovery-day-picker .picker-area').append(j);
        }

        $('.recovery-day-picker .recovery-point-date:eq(3)').addClass('selected');

        const rp_holder = $('.recovery-time-picker').find('.recovery-points');
        const rp_item_template = $('.recovery-time-picker > .recovery-point-time');
        rp_holder.empty();

        let points = dates[3].points;
        $.each(points, function(k, v) {
            const rp_item = rp_item_template.clone();
            const prev_rp_time = (points[k - 1]) ? points[k - 1].ts : v.ts;
            const hourDiff = Math.max(0, Math.floor((v.ts - prev_rp_time - 600) / 3600));
            const gap = hourDiff % 24;

            rp_item.find('.time').html(v.time + '<span>' + v.ampm + '</span>');
            rp_item.find('.recovery-btn a').data('rpoint', v.str);
            rp_item.find('.recovery-btn a').data('rpointTs', v.ts);
            rp_item.addClass('gap-' + gap);
            if (!v.enabled) {
                rp_item.find('.recovery-btn a').addClass('disabled');
            }
            rp_holder.append(rp_item);
        });

        const dpo = $('#recovery-point-date-picker');

        dpo.datepicker('setDate', dates[3].date.full);
        dpo.datepicker('option', 'minDate', data.timeline.min);
        dpo.datepicker('option', 'maxDate', data.timeline.max);

        $('.recovery-day-picker .recovery-point-date:not(.no-rpts):not(.selected)').click(function(){
            if ($(this).hasClass('disabled')) {
                return;
            }
            data.timeline = { selected: $(this).data('date'), dpoint: $(this).data('dpoint') };
            fr.callMethod('loadRP');
        });

        const first = $('.recovery-day-picker .recovery-point-date:first');
        if (first.is('.no-rpts') || (first.data('date') == data.timeline.min)) {
            $('.recovery-day-picker .get-prev').addClass('disabled');
        }

        const last = $('.recovery-day-picker .recovery-point-date:last');
        if (last.is('.no-rpts') || (last.data('date') == data.timeline.max)) {
            $('.recovery-day-picker .get-next').addClass('disabled');
        }

        $('.recovery-day-picker .get-next:not(.disabled)').click(function() {
            data.timeline = { selected: null, dpoint: data.timeline.next };
            fr.callMethod('loadRP');
        });

        $('.recovery-day-picker .get-prev:not(.disabled)').click(function() {
            data.timeline = { selected: null, dpoint: data.timeline.prev };
            fr.callMethod('loadRP');
        });

        $('.recovery-time-picker .recovery-btn a').click(function(){
            if ($(this).hasClass('disabled')) {
                return;
            }
            data.tmp.previousStep = fr.currentStep;
            data.recovery.point = $(this).data('rpoint');
            data.recovery.pointTs = $(this).data('rpointTs');
            // this is where onsite and offsite and vmdk export file recovery split up
            if (isExportToDisk(data)){
                fr.goTo("exportVm");
            }
            else if (data.restore.type === "cloud")
                fr.goTo("browse");
            else if (data.restore.type === "appliance")
                fr.goTo("exposeCifsShare");
        });
    }

    transitionBack(data, el, fr) {
        if (isExportToDisk(data)) {
            if (data.deviceId) {
                fr.goTo("locateVirtualization");
            } else {
                delete data.recovery.device_id;
                fr.goTo("setDevice");
            }
        } else {
            switch (data.tmp.previousStep) {
                case "setDevice" :
                case "restoreType" :
                    delete data.recovery.device_id;
                    break;
            }
            fr.goTo(data.tmp.previousStep);
        }
    }

}
